import React from 'react';
import './Reviews.css';

const reviews = [
  {
    name: 'Tyler H.',
    role: 'Player, U16 AAA',
    review: 'The coaches at RFR Pro completely changed my game. I\'m faster, more confident with the puck, and finally getting noticed by scouts.',
  },
  {
    name: 'Brayden S.',
    role: 'Player, Midget AA',
    review: 'Training with RFR Pro is like nothing else. These guys have actually played at high levels and it shows. Best decision I\'ve made for my development.',
  },
  {
    name: 'Liam C.',
    role: 'Parent',
    review: 'My son looks forward to every session. His shot is stronger, his skating improved, and his love for the game has never been higher.',
  },
  {
    name: 'Mason R.',
    role: 'Player, Bantam AA',
    review: 'RFR Pro is the real deal. Their one-on-one attention and game-specific drills helped me make the jump to AAA this season.',
  },
  {
    name: 'Avery T.',
    role: 'Player, Peewee AAA',
    review: 'The coaches treat every player like a pro. It\'s intense, but supportive. My hockey IQ and confidence are at another level now.',
  },
];

const Stars = () => (
  <div className="review-stars" aria-label="5 stars">
    {Array.from({ length: 5 }).map((_, i) => (
      <span key={i}>★</span>
    ))}
  </div>
);

const Reviews = () => (
  <div className="reviews-page">
    <div className="reviews-page__hero">
      <h1>What Players & Parents Say</h1>
      <p>Real feedback from athletes and families who trust RFR Pro with their hockey journey.</p>
    </div>

    <div className="reviews-page__body">
      <div className="reviews-grid">
        {reviews.map((r, i) => (
          <div className="review-card" key={i}>
            <Stars />
            <blockquote className="review-card__text">"{r.review}"</blockquote>
            <div className="review-card__footer">
              <span className="review-card__name">{r.name}</span>
              <span className="review-card__role">{r.role}</span>
            </div>
          </div>
        ))}
      </div>

      <div className="reviews-aggregate">
        <span className="reviews-aggregate__score">5.0</span>
        <div>
          <div className="reviews-aggregate__stars">★★★★★</div>
          <span className="reviews-aggregate__count">Based on {reviews.length} reviews</span>
        </div>
      </div>
    </div>
  </div>
);

export default Reviews;
